<template>
  <div>
    <div class="row">
      <div class="col-12">
        <Fullcalendar
          v-if="calendarSystem === CalendarSystem.GREGORIAN"
          ref="fullCalendar"
          :options="calendarOptions"
        />
        <EthiopianFullCalendar
          v-else
          ref="ethCalendar"
          :events="ethEvents"
          @date-select="handleEthSelect"
          @event-click="handleEthEventClick"
          @month-change="handleEthMonthChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import '@fullcalendar/core'
import Fullcalendar from '@fullcalendar/vue3'
import EthiopianFullCalendar from '@/components/holiday/Ethiopian_Full_Calendar.vue';
import { CalendarSystem } from '@/utils/enums';

export default {
  props: {
    calendarOptions: {
      type: Object,
      required: true,
    },
  },
  components: {
    Fullcalendar,
    EthiopianFullCalendar,
  },
  data() {
    return {
      CalendarSystem,
    }
  },
  computed: {
    calendarSystem() {
      return this.account?.organization?.calendarSystem || CalendarSystem.GREGORIAN;
    },
    account() {
      return this.$store.getters.account.data
    },
    dashboardStats() {
      return this.$store.getters.dashboardStats.data;
    },
    ethEvents() {
      return this.calendarOptions?.events || this.dashboardStats?.employeeAttendance || [];
    },
  },
  methods: {
    handleEthSelect(e) {
      if (this.calendarOptions?.select) {
        this.calendarOptions.select({ startStr: e.startStr });
      }
    },
    handleEthEventClick(evt) {
      if (this.calendarOptions?.eventClick) {
        this.calendarOptions.eventClick({
          event: {
            _def: {
              publicId: evt.id,
              extendedProps: evt.extendedProps || {}
            }
          }
        });
      }
    },
    handleEthMonthChange() {
      // Dashboard calendar is read-only with pre-loaded stats; no re-fetch needed on navigation
    },
  },
}
</script>